import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Download, RefreshCw, WifiOff } from "lucide-react";
import { useMkRoot } from "@/app/branding";
import { installApp, usePwa } from "./runtime";

export function PwaOfflineNotice() {
    const { t } = useTranslation();
    const root = useMkRoot();
    const { offline } = usePwa();
    if (!offline) return null;
    return <aside className="mk pm-pwa-notice" {...root} aria-live="polite" aria-atomic="true">
        <WifiOff size={19} aria-hidden="true" /><span>{t("pwa.offline")}</span>
    </aside>;
}

/** Installation belongs to the personal menu; the home navigation stays intact. */
export function PwaInstall() {
    const { t } = useTranslation();
    const state = usePwa();
    const [instructions, setInstructions] = useState(false);
    if (state.installed) return null;
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent)
        || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    const secure = window.isSecureContext;
    return <section className="pm-pwa-install">
        <img src="/pwa/icon-192.png" alt="" width="44" height="44" />
        <div><strong>{t("pwa.installTitle")}</strong>
            <p>{t("pwa.installDescription")}</p>
            {instructions && <p role="status">{t(!secure ? "pwa.httpsRequired" : ios ? "pwa.iosInstall" : "pwa.browserInstall")}</p>}
        </div>
        <button type="button" onClick={() => state.installPrompt ? void installApp() : setInstructions(!instructions)}
            aria-expanded={state.installPrompt ? undefined : instructions}>
            <Download size={17} aria-hidden="true" />{t("pwa.install")}
        </button>
    </section>;
}

export function ConnectionScreen({ retry }: { retry(): void }) {
    const { t } = useTranslation();
    const root = useMkRoot();
    const { offline } = usePwa();
    return <main className="mk pm-pwa-connection" {...root}>
        <div><img src="/pwa/icon-192.png" alt="" width="72" height="72" />
            <h1>{t(offline ? "pwa.connectionOffline" : "pwa.connectionFailed")}</h1>
            <p>{t("pwa.connectionHint")}</p>
            <button type="button" onClick={retry}><RefreshCw size={18} aria-hidden="true" />{t("app.retry")}</button>
        </div>
    </main>;
}
